import { MenuItem } from './types';

export const MENU_ORDER = [MenuItem.Imports, MenuItem.Payments, MenuItem.Escrow];
